// extracted by mini-css-extract-plugin
export default {"root":"ThemeSwitcher_root__XwBcY"};